import React from "react";

export default function Thumbs() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50pt"
      height="50pt"
      viewBox="0 0 50 50"
      version="1.1"
    >
      <g id="surface47927">
        <path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "rgb(9.019608%,18.039216%,26.27451%)",
            fillOpacity: 1,
          }}
          d="M 6.667969 41.667969 L 10 41.667969 C 12.136719 43.800781 15.027344 45 18.046875 45 L 35 45 L 38.332031 41.667969 L 38.332031 35 L 39.167969 18.332031 L 23.332031 18.332031 C 23.332031 18.332031 25 12.890625 25 11.667969 C 25 7.914062 25 3.332031 20 3.332031 C 18.332031 3.332031 18.332031 3.332031 18.332031 3.332031 L 17.5 9.152344 L 13.554688 16.488281 C 12.390625 18.652344 10.136719 20 7.683594 20 L 6.667969 20 Z M 6.667969 41.667969 "
        />
        <path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "rgb(9.019608%,18.039216%,26.27451%)",
            fillOpacity: 1,
          }}
          d="M 39.167969 18.332031 C 36.867188 18.332031 35 20.199219 35 22.5 C 35 24.800781 36.867188 26.667969 39.167969 26.667969 C 41.46875 26.667969 43.332031 24.800781 43.332031 22.5 C 43.332031 20.199219 41.46875 18.332031 39.167969 18.332031 Z M 37.5 31.667969 C 35.199219 31.667969 33.332031 33.53125 33.332031 35.832031 C 33.332031 38.132812 35.199219 40 37.5 40 C 39.800781 40 41.667969 38.132812 41.667969 35.832031 C 41.667969 33.53125 39.800781 31.667969 37.5 31.667969 Z M 37.5 31.667969 "
        />
        <path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "rgb(9.019608%,18.039216%,26.27451%)",
            fillOpacity: 1,
          }}
          d="M 39.167969 25 C 36.867188 25 35 26.867188 35 29.167969 C 35 31.46875 36.867188 33.332031 39.167969 33.332031 C 41.46875 33.332031 43.332031 31.46875 43.332031 29.167969 C 43.332031 26.867188 41.46875 25 39.167969 25 Z M 35 38.332031 C 33.160156 38.332031 31.667969 39.824219 31.667969 41.667969 C 31.667969 43.507812 33.160156 45 35 45 C 36.839844 45 38.332031 43.507812 38.332031 41.667969 C 38.332031 39.824219 36.839844 38.332031 35 38.332031 Z M 35 38.332031 "
        />
        <path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "rgb(9.019608%,18.039216%,26.27451%)",
            fillOpacity: 1,
          }}
          d="M 35 38.332031 C 33.160156 38.332031 31.667969 39.824219 31.667969 41.667969 C 31.667969 43.507812 33.160156 45 35 45 C 36.839844 45 38.332031 43.507812 38.332031 41.667969 C 38.332031 39.824219 36.839844 38.332031 35 38.332031 Z M 35 38.332031 "
        />
      </g>
    </svg>
  );
}
